import script from "./CalendarSlot.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarSlot.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarSlot.vue?vue&type=style&index=0&id=030c138a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030c138a"]])

export default __exports__